"use strict";
import "./factor_invoices_service";
import pusherFactory from "./pusher_factory";
var FactorInvoiceUpdateService = function() {
  var instance = {
    logging: true,
    ready: true,
    pingFrequency: 1e3 * 60,
    // one minute
    timeoutInterval: 1e3 * 60 * 3,
    // three minutes
    pusher: function() {
      if (typeof Pusher == "undefined") return;
      return pusherFactory.createInstance();
    },
    listenForGeocodeUpdates: function(pusher, emailId) {
      var channelName = "email-message-" + emailId + "-updates";
      if (pusher.channel(channelName)) {
        this.channel = pusher.channel(channelName);
      } else {
        this.unsubscribeFromAllChannels(pusher);
        this.channel = pusher.subscribe(channelName);
      }
      this.channel.bind("client-hubtran:geocoding_updated", this.triggerInvoiceUpdated);
    },
    unsubscribeFromAllChannels: function(pusher) {
      let channelNames = _.keys(pusher.channels.channels);
      _.each(channelNames, function(channel) {
        pusher.unsubscribe(channel);
      });
    },
    triggerInvoiceUpdated: function() {
      $(instance).trigger("FactorInvoiceUpdateService:invoiceUpdated");
    }
  };
  return instance;
};
var FactorInvoiceUpdateService = new FactorInvoiceUpdateService();
export default FactorInvoiceUpdateService;
